module.exports = __webpack_public_path__ + "img/ac6fdf4.jpg";